import { render } from "./candidateRefere.vue?vue&type=template&id=f2c0b90c&ts=true"
import script from "./candidateRefere.vue?vue&type=script&lang=ts"
export * from "./candidateRefere.vue?vue&type=script&lang=ts"

import "./candidateRefere.vue?vue&type=style&index=0&id=f2c0b90c&lang=scss"

import exportComponent from "/codebuild/output/src2155066187/src/reference-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__